import { freespinsPopupsFont } from '../../fontStyles';
import BasePopup from './BasePopup';
import { gsap } from 'gsap';
import EntryPoint from 'Engine/EntryPoint';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import BaseMoneyFormat from 'Engine/base/moneyFormat/MoneyFormat';
import SoundManager from 'Engine/soundManager/SoundManager';
import eSounds from '../../sounds/eSoundType';
import eEventTypes from '../../enums/eEventTypes';
import animationCreator from 'Engine/animations/animationCreator';
import eAnimationTypes from '../../animations/animationTypes';

export default class ControllerFreespinsEnd extends BasePopup {
  constructor(data, displayData) {
    super(data, displayData);
    this.alpha = 0;

    this._valueAnimationDuration = 2000;
    this._idleDuration = 2000;
    this._targetValue = 0;

    this.init();
    this.initAnimation();
  }

  init() {
    super.init();
    this.container = this.wrapper.getChildByName('container');
    this.totalWinLabel = this.container.getChildByName('freespins_popup_end_total_win');
    this.textFieldTotalWin = this.wrapper.getChildByName('amount');
    this.totalWinLabel.adaptiveResolution = true;
    this.textFieldTotalWin.adaptiveResolution = true;
    this.totalWinLabel.correctPosition('center', 'center');
    this.setTextStyle();
    this.createMask(this.container);
  }

  initAnimation() {
    // this.animation = animationCreator.createAnimation(eAnimationTypes.BIG_WIN);
    // this.animation.visible = false;
    // this.wrapper.getChildByName('animationPlace').addChild(this.animation);
  }

  setTextStyle() {
    this.totalWinLabel.style = { ...this.totalWinLabel.style, ...freespinsPopupsFont };
    this.textFieldTotalWin.style = { ...this.textFieldTotalWin.style, ...freespinsPopupsFont };
  }

  show(delay) {
    super.show(delay);
    const arrForDecimals = BaseMoneyFormat.formatCurrency(EntryPoint.GameModel.freespinsTotalWin, EntryPoint.GameModel.currencyInfo.decimals).split('.');
    this.decimalsForAnimation = arrForDecimals[1] ? arrForDecimals[1].length : 0;

    this._targetValue = EntryPoint.GameModel.freespinsTotalWin;
    SoundManager.play(eSounds.EST_FS_TOTAL_WIN, 0.6, false, 'winning');
    this.playAnimation();
    this.startMaskUpdate(this.container);
    requestAnimationFrame(this._animateValue.bind(this));
  }

  playAnimation() {
    // this.animation.state.setAnimation(0, eAnimationNames.EAN_FREE_SPINS_END__START, false);
    // this.animation.state.addAnimation(0, eAnimationNames.EAN_FREE_SPINS_END__IDLE, true, 0);
    // this.animation.visible = true;
  }

  stopAnimation() {
    // this.animation.visible = false;
    // this.animation.state.clearTrack(0);
    // this.animation.lastTime = null;
  }

  onShow() {
    super.onShow();
    GlobalDispatcher.dispatch(eEventTypes.EET_FREESPINS_END__SHOWN_UP);
  }

  onHide() {
    super.onHide();
    this.totalWin = 0;
    this.stopAnimation();
    GlobalDispatcher.dispatch(eEventTypes.EET_FREESPINS_END__ON_COMPLETE)
  }

  stopMainBackgroundSound() {
    const sound = SoundManager.getSound(eSounds.EST_BONUS_GAME_BACKGROUND);
    gsap.to(sound, {
      volume: 0,
      duration: 0.5,
      onComplete: () => SoundManager.pause(eSounds.EST_BONUS_GAME_BACKGROUND)
    });
  }

  _animateValue(timestamp) {
    if (!this._startValueAnimationTime) this._startValueAnimationTime = timestamp;
    const diff = timestamp - this._startValueAnimationTime;

    if (diff >= this._valueAnimationDuration) {
      this.totalWin = this._targetValue;
      this._startValueAnimationTime = null;
      requestAnimationFrame(this._idle);
      return;
    }

    const progress = diff / this._valueAnimationDuration;
    this.totalWin = this._targetValue * progress;

    requestAnimationFrame(this._animateValue.bind(this));
  };

  set totalWin(value) {
    this._totalWin = value;
    this.textFieldTotalWin.text = parseFloat(value).toFixed(this.decimalsForAnimation);
  }

  get totalWin() {
    return this._totalWin;
  }
}
